.admin-home {
  max-width: 720px;
  margin: 0 auto;
  padding: 3rem 1rem 2rem;
  text-align: left;
}

.admin-title {
  position: relative;
  display: inline-block;
  margin-bottom: 2rem;
}

.admin-title-logo {
  height: 64px;
  width: auto;
}

.admin-title-context {
  position: absolute;
  top: 63px;
  left: 47px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--umati-blue-admin);
}

.greeting {
  margin-bottom: 0.5rem;
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--umati-text);
}

.admin-intro {
  max-width: 640px;
  margin-bottom: 1.5rem;
  line-height: 1.45;
  color: #4b5563;
}

.role-card {
  padding: 1.2rem 1.4rem;
  background-color: #fff;
  border: 1px solid #e0edff;
  border-left: 5px solid var(--umati-blue);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgb(0 160 227 / 6%);
}

.role-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.65rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #9ca3af;
}

.role-card h3 {
  margin: 0 0 0.4rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--umati-blue);
}

.role-summary {
  margin-bottom: 0.8rem;
  font-size: 0.9rem;
  color: #4b5563;
}

.role-card ul {
  margin: 0;
  padding-left: 1.1rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.role-card li + li {
  margin-top: 0.3rem;
}

.admin-hint {
  margin-top: 1.5rem;
  font-size: 0.875rem;
  color: #6b7280;
}
